import { FC, useContext, } from "react";
// 方法
import { getFormItem } from "../hook/getFormItem";
import RowContext from "../context/rowContext";
// 常量
import { TableCellProps, MAIN_ROW_KEY, } from "../interface";

const TableCell: FC<TableCellProps> = props => {
  const { children, record, editable, disabled, disabledRender, formItemType, SimpleFormItemProps, rowIndex,  ...restProps } = props;
  const form = useContext(RowContext);
  
  const renderChildren = () => {
    /** 主表 */
    if (record?.[MAIN_ROW_KEY]) {
      return children;
    }
    /** 是否可编辑 */
    if (editable) {
      /** 是否禁用 */
      if (disabled && disabledRender) {
        return typeof disabledRender === 'function' ? disabledRender(record) : disabledRender;
      }
      return getFormItem(record, {...SimpleFormItemProps, formItemType, disabled, form, rowIndex} );
    }
    return children;
  };
  return (
    <td {...restProps}>
      {renderChildren()}
    </td>
  );
};

export default TableCell;
